import React from "react"
import styled from "styled-components"
import StickyLogo from "../components/logo"

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 3rem;
`

const Header = () => {
  return (
    <HeaderContainer>
      <StickyLogo width="125px" />
    </HeaderContainer>
  )
}

export default Header